import React, { useEffect, useState } from 'react';
import { useTankCleaningStore } from '../../../context/TankCleaningContext';
import { PortCall } from '../../../types/ViewModel/PortCall';
import { ChemicalRobReportItem } from '../../../types/ViewModel/TankCleaning/ROB/ChemicalRobReportItem';
import { ChemicalCategoryList, ChemicalCategoryWrapper, RobItemRow } from './ReportRob.styles';

type Props = {
    chemicalRobReportItems: ChemicalRobReportItem[];
    previousPortCallWithRob?: PortCall;
    selectedPortCallId: number;
};

const ChemicalCategoryReportItemsSummaryComponent: React.FC<Props> = (props) => {
    const { robLocationDDList } = useTankCleaningStore();
    const [ddValuesList, setDDValuesList] = useState<string[]>([]);

    // =============  Use Effects ================
    useEffect(() => {
        if (robLocationDDList && robLocationDDList.length > 0) {
            const _ddValuesList: string[] = [];
            robLocationDDList.forEach((robLocationDDCategory) => {
                robLocationDDCategory.robLocationDropdownItemList.forEach((robLocationDDItem) => {
                    _ddValuesList[robLocationDDItem.robLocationDropdownItemId] = robLocationDDItem.name;
                });
            });
            setDDValuesList(_ddValuesList);
        }
    }, [robLocationDDList]);

    const getDDListValue = (robLocationDropdownItemId: number) => {
        if (robLocationDropdownItemId && ddValuesList && ddValuesList.length > 0) {
            return ddValuesList[robLocationDropdownItemId];
        }
        return 0;
    };

    const getPreviousItemValue = (chemicalRobReportItem: ChemicalRobReportItem) => {
        const chemicalRobForPortCall = props.previousPortCallWithRob?.chemicalRobForPortCall;
        if (chemicalRobForPortCall) {
            const previousRobItem = chemicalRobForPortCall.chemicalRobItemList.find(
                (c) => c.chemicalId === chemicalRobReportItem.chemical.chemicalId
            );
            if (previousRobItem) {
                return previousRobItem.robValue;
            }
        }
        return 0;
    };

    return (
        <ChemicalCategoryWrapper>
            {ddValuesList && ddValuesList.length > 0 && props.chemicalRobReportItems && props.chemicalRobReportItems?.length > 0 && (
                <ChemicalCategoryList>
                    {props.chemicalRobReportItems.map((chemicalRobReportItem, index) => {
                        if (chemicalRobReportItem.robValue > 0) {
                            return (
                                <li key={`robReportItem_${props.selectedPortCallId}_${chemicalRobReportItem.chemical.chemicalId}_${index}`}>
                                    <RobItemRow>
                                        <label>{chemicalRobReportItem.chemical.name}</label>
                                        <span className="rob-value">
                                            {getPreviousItemValue(chemicalRobReportItem)}
                                            <span className="unit">{chemicalRobReportItem.chemical.unit?.unitName}</span>
                                        </span>
                                        <span className="location">
                                            <span>
                                                {getDDListValue(chemicalRobReportItem.chemicalRobItemLocationList[0]?.robLocationDropdownItemId)}
                                            </span>
                                            <span className="rob-value">
                                                {chemicalRobReportItem.chemicalRobItemLocationList[0]?.robValue}
                                                <span className="unit">{chemicalRobReportItem.chemical.unit?.unitName}</span>
                                            </span>
                                        </span>
                                        <span className="location">
                                            <span>
                                                {getDDListValue(chemicalRobReportItem.chemicalRobItemLocationList[1]?.robLocationDropdownItemId)}
                                            </span>
                                            <span className="rob-value">
                                                {chemicalRobReportItem.chemicalRobItemLocationList[1]?.robValue}
                                                <span className="unit">{chemicalRobReportItem.chemical.unit?.unitName}</span>
                                            </span>
                                        </span>
                                        <span className="location">
                                            <span>
                                                {getDDListValue(chemicalRobReportItem.chemicalRobItemLocationList[2]?.robLocationDropdownItemId)}
                                            </span>
                                            <span className="rob-value">
                                                {chemicalRobReportItem.chemicalRobItemLocationList[2]?.robValue}
                                                <span className="unit">{chemicalRobReportItem.chemical.unit?.unitName}</span>
                                            </span>
                                        </span>
                                        <span className="rob-value">
                                            {chemicalRobReportItem.robValue}
                                            <span className="unit">{chemicalRobReportItem.chemical.unit?.unitName}</span>
                                        </span>
                                    </RobItemRow>
                                </li>
                            );
                        }
                    })}
                </ChemicalCategoryList>
            )}
        </ChemicalCategoryWrapper>
    );
};

export default ChemicalCategoryReportItemsSummaryComponent;
